import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionOutsidePlant2.mp4",
    poster: "/videos/solutionOutsidePlant2.jpg",
    heading: "CONNECTED COMMUNITIES RELY ON OUTSIDE PLANT SOLUTIONS",
    subheading: "Fiber optics are connecting communities and transforming the way we live. If you are ready to deliver more and do more for your community, we can help.",
    buttonLink: "/solutions"
  }
];

function SolutionCentralOffice() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  'Cassettes',
  'Fiber Panels',
  'Fiber Terminals & Closures',
];

// 

const rows = [
  {
    need: "To lower my cost per home passed",
    feature: "Plug-and-play products that minimize splice labor requirements",
    benefit: "Lower project cost with reduced splicing and increased turn-up speed",
  },
  {
    need: "To reduce inventory SKUs",
    feature: "Modular solutions that do not require proprietary connectors",
    benefit: "Reduce inventory and overhead",
  },
  {
    need:
      "A solution to scale (unsure of my needs beyond today OR don’t want to pay for more than I need now)",
    feature: "Modular solutions that can be upgraded in the field",
    benefit: "Add capacity as you need it",
  },
  {
    need: "Easy and quick to install and upgrade solutions",
    feature: "Thoughtful designs for easy field installation & maintenance",
    benefit:
      "Saves time, money, minimizes mistakes, increases uptime",
  },
  {
    need: "A custom solution for my unique application",
    feature: "Highly skilled engineers can quickly address specific needs",
    benefit:
      "Ease installation and stay on schedule with rapid development of custom solutions",
  },
  {
    need: "High-quality product with guaranteed performance",
    feature:
      "Product certified by 3rd party labs to meet or exceed industry standards",
    benefit: "Minimize product failure in the field",
  },
  {
    need: "Made-in-USA products to comply with BABA/BEAD requirements",
    feature: "BABA/BEAD compliant products",
    benefit: "Qualify projects for federal funding",
  },
  {
    need: "A second supplier is needed",
    feature: "Request a sample and meet performance and lead-time requirements",
    benefit: "Stay on schedule and minimize risk",
  },
  {
    need: "Purchase a large number of products quickly",
    feature: "Build to forecast and warehouse in the USA",
    benefit: "Purchase and get product when you need it",
  },
  {
    need: "A compact solution to minimize visual clutter & save space",
    feature:
      `PEACOC Spreadable Adapter technology allows for more terminations in smaller product footprints`,
    benefit: "Accessible high-density solutions in a compact size",
  },
];

const posts = [
  {
      id: "01",
      category: "Infrastructure",
      tags: ["AI", "Data Centers"],
      title: "The Networking Skilled Labor Gap: The realities and remedies",
      date: "02 / 25 / 2026",
      excerpt: "In the last 2 years, just about every conversation I have regarding network infrastructure new builds and installations always lead to the same question, “Where are you finding quality technicians and engineers right now?”.",
      img: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FBlogSkilledLabor.jpeg?alt=media&token=a6258f5f-6e1c-4616-8f6c-8c39eb65776c",
      url: "https://gofoton.com/the-networking-skilled-labor-gap"
    }
  ];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

  const [startIndex, setStartIndex] = useState(0);

  const next = () => {
    if (startIndex + 3 < topByFamily.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1" style={{marginTop: 50}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/outsidePlant.png" alt="Outside Plant" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Hey, network operators, connect everyone everywhere!</h2>
          <p className="solution-section-1-description">Think about how communication networks have evolved over the past few decades. Homes have gone from a land-line telephone and dial-up internet to numerous connected devices, streaming services, and home offices, all essential to everyday life. And with emerging AI and 6G (to name a few) technologies, it’s almost impossible to imagine what we’ll be saying about broadband application as a utility in another few years. Things change fast in our world. And there are innumerable connections that make these changes possible.

<br/><br/>Whether you’re rolling out service to new subscribers, transitioning your network from GPON to xGPON, preparing for 6G and the influx of capacity demands from AI-based technology, your outside plant network is always adapting and changing. But unlike the core, keeping pace with the changes can be incredibly costly and time consuming. With skilled labor shortages and increasing costs, there’s more pressure on technology to keep cost-per-home-passed down and flexibility and simplicity up. In fact, several financial, technical, and even social pressures weigh on your connectivity choices.</p>
        </div>
      </div>


        <div className="solutions-icon-grid-2" style={{ marginRight: '4vw', marginLeft: '4vw'}}>
            <div className="icon-item">
              <img src="/images/icons/climate.webp" alt="Icon 1" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10}}>Climate​</p>
              <p>Dramatic weather patterns & unique terrain demand ruggedized protection​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/government.webp" alt="Icon 2" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Government Funding</p>
              <p>Terms may require in-country sourcing of solutions​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/labor.webp" alt="Icon 3" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Skilled Labor</p>
              <p>Intuitive & easy-to-use solutions are preferred to keep it simple for installers of any skill level</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/home.webp" alt="Icon 4" />
              <p style={{ color: '#85246D', fontWeight: 'bold', marginBottom: 10 }}>Aesthetics</p>
              <p>Residents insist on small & unobtrusive equipment in their neighborhoods​</p>
            </div>
            <div className="icon-item">
              <img src="/images/icons/cost.webp"alt="Icon 5" />
              <p style={{ color: '#85246D', fontWeight: 'bold' , marginBottom: 10}}>Cost</p>
              <p>Modular solutions ensure you can add services when the demand requires​</p>
            </div>
          </div>


      <FactoidSection
        solution="outside-plant"
        title="The best broadband has a flexible fiber backbone"
        description=""
      />

<center>
        <h2 className="solutions-section-factoids-header">
Does any of this sound like you?
        </h2></center>

                 <img
  src="/images/solutions/ospTable.png"
  alt="Datacenter Table"
  className="responsive-image-table"
/>

 <div className="nfb-table">
      <div className="nfb-row nfb-header">
        <div className="nfb-cell nfb-need">I need…</div>
        <div className="nfb-cell nfb-feature">Go!Foton Feature</div>
        <div className="nfb-cell nfb-benefit">Your Benefit</div>
      </div>

      {rows.map((r, i) => (
        <div className="nfb-row" key={i}>
          <div className="nfb-cell nfb-need">{r.need}</div>
          <div className="nfb-cell nfb-feature">{r.feature}</div>
          <div className="nfb-cell nfb-benefit">{r.benefit}</div>
        </div>
      ))}
    </div>

          <div className="solutions-section-imageBackground-osp" style={{ marginTop: 80, position: 'relative'}}>
        <div className='curved-divider-top' />
        <div className="solutions-section-imageBackground-text-container">
            <a href="https://broadbandusa.ntia.gov/technical-assistance/BABA_Compliance_and_Self_Certification" target="_blank"><img src="/images/solutions/BEADCompliant.png" style={{ height: 60, width: 60}} /></a>
            <h2>Building broadband at home</h2>
            <p style={{ marginBottom: 30}}>Helping communities connect with BEAD & BABA compliant solutions</p>
            <a href={'/bead'} className="single-cta-button">
              Learn More
            </a>
      </div>
      <div className='curved-divider-bottom' />
      </div>

<center>
    <section className="architecture-section">
      <div className="architecture-content">
        <div className="architecture-left">
          <h2 className="architecture-title">Your architecture, your way</h2>
          <p className="architecture-paragraph">
            To ensure everyone has access to reliable internet, our solutions are
            developed to support a variety of network architectures: centralized,
            distributed, distributed tap, wireless, and more. Each approach has
            unique benefits and drawbacks.
          </p>
          <p className="architecture-paragraph">
            At Go!Foton, we are always searching for a better, more efficient and
            effective way to build networks. Go!Foton has also introduced
            <strong> Decentralized Split Architecture</strong> that combines the
            strengths of existing models while minimizing their drawbacks. This
            new approach has the potential to revolutionize FTTH deployments with
            faster installation times, reduced costs, and simplified maintenance.
            We invite you to learn more!
          </p>
<a
  href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/whitepapers%2FDecentralized%20Split%20Architecture%20White%20Paper.pdf?alt=media&token=e0e52f9b-e6a6-4b37-8c3a-ba620dcf5fd3"
  className="cta-button"
  target="_blank"
  rel="noopener noreferrer"
>            DOWNLOAD THE WHITE PAPER
          </a>
        </div>

        <div className="architecture-right">
          <img
            src="/images/communityView.png"
            alt="Neighborhood Aerial View"
            className="architecture-image"
          />
          <div className="architecture-highlight">
            <p>
              <strong>
                Decentralized Split Architecture reduced overall project costs by{" "}
                <span className="highlight-percentage">80%</span>
              </strong>{" "}
              in a 128-home neighborhood!
            </p>
            <p>
              The savings were attributed to smaller cabling requirements,
              reduced materials, and a near-elimination of splice labor costs.
            </p>
          </div>
        </div>
      </div>
    </section>
    </center>

<section className="connectivity-section">
      <div className="connectivity-container">
        
        {/* Left Image */}
        <div className="connectivity-left">
          <img
            src="/images/construction.png"
            alt="Construction and Cable Installation"
            className="connectivity-image"
          />
        </div>

        {/* Right Text */}
        <div className="connectivity-right">
          <h2 className="connectivity-title">
            Connectivity that is as unique as you are
          </h2>
          <p className="connectivity-paragraph">
            While the cost of connectivity may be fractional compared to optical
            fiber and labor, connectivity is just as essential an ingredient for
            delivering broadband. Connectivity enables the information flow and
            ultimately the consumer experience. And making the right choice in
            connectivity impacts network operators’ ability to:
          </p>
          <ul className="connectivity-list">
            <li>Scale operations, adding network capacity</li>
            <li>Manage network capacity for growth with modular solutions</li>
            <li>
              Easily manage and maintain networks with technician friendly designs for field work
            </li>
            <li>
              Run and break out high-speed connections when and where they are needed
            </li>
          </ul>
          <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/brochures%2FOutside%20Plant%20Brochure.pdf?alt=media&token=5d50b2a4-7183-4dd2-a9cb-79bcc31d494a" className="cta-button">
            DOWNLOAD BROCHURE
          </a>
        </div>

      </div>
    </section>

    <section className="solution-products-section-2" style={{ position: 'relative', paddingTop: 100, paddingBottom: 80, width: '120vw'}}>
      <div className='curved-divider-top' />
      <center><h2>Next-Gen Fiber Solutions for the Outside Plant</h2></center>
      <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p>


      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}

<div className="article-slider-container">
  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-left ${familyIndex === 0 ? "disabled" : ""}`}
      onClick={prevFamily}
      disabled={familyIndex === 0}
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${familyIndex * (100 / familySlidesPerView)}%)`,
        "--content-slides-per-view": familySlidesPerView,
      }}
    >
      {topByFamily.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="image-slider-card">
            <div className="image-logo-wrapper">
              <img
                src={
                  article.topProduct
                    ? article.topProduct.image
                    : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Data%20Center%20Image%20(1).jpg?alt=media&token=367424a2-ef6c-4e88-a8dc-8ac186a99ac1"
                }
                alt="logo"
                className="image-logo"
              />
            </div>

            <h3>{article.family}</h3>

            <a
              className="cta-button"
              href={article.topProduct ? `/${article.slug}` : `/services`}
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-right ${familyIndex === familyMaxIndex ? "disabled" : ""}`}
      onClick={nextFamily}
      disabled={familyIndex === familyMaxIndex}
    >
      &#10095;
    </button>
  )}
</div>

<div className='curved-divider-bottom' />

    </section>


      <div className="solutions-section-centeredText">
        <div className="solutions-section-centeredText-text-container">
          <h2 className="solutions-section-centeredText-subheading">News & Events</h2>
          <p className="solution-section-centeredText-description">We’re proud to be a part of this important industry that plays a part in how we live and work each day. Our priority is designing outside plant connectivity to help you reach more subscribers easily and fast. Let’s stay connected.​ ​</p>
<div className="partner-logos-wrapper">
  {/* Fiber Broadband Association */}
  <a href="https://fiberbroadband.org/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FFiber-Broadband-Association-300x171.png?alt=media&token=55d25c7a-6a0a-4cfb-84a2-5ec8fc3eafb6" 
      alt="Fiber Broadband Association" 
    />
  </a>

  {/* Fiber Connect 25 */}
  <a href="https://fiberconnect.fiberbroadband.org/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FFC25_Horizonal_Color.webp?alt=media&token=0d5f8750-aa52-4f49-9bf9-2771e640643e" 
      alt="Fiber Connect 25" 
    />
  </a>

  {/* OFC 50 */}
  <a href="https://www.ofcconference.org/home/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Flogo_ofc50-300x134.png?alt=media&token=a2c1eda8-7739-487a-9a3e-878567231818" 
      alt="OFC 50" 
    />
  </a>

  {/* ISE Expo */}
  <a href="https://www.iseexpo.com/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FISEEXPO_logo-300x167.png?alt=media&token=7e516d63-6ee2-4a90-ae8e-bedccacc432d" 
      alt="ISE Expo" 
    />
  </a>

  {/* SCTE TechExpo 25 */}
  <a href="https://techexpo.scte.org/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2Fscte-logo-2025.webp?alt=media&token=a47e5bac-1197-47cb-ad73-89c383211c76" 
      alt="SCTE TechExpo 25" 
    />
  </a>

  {/* NEW: Optica */}
  <a href="https://www.optica.org/" target="_blank" rel="noopener noreferrer">
    <img 
      src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FOptica.png?alt=media&token=89d16d67-fc45-426d-9add-009b7341d2e3" 
      alt="Optica" 
    />
  </a>
</div>
        </div>
      </div>


<div className="blog-container">
  <center><h2 className="solutions-section-centeredText-subHeading" style={{ marginBottom: "60px"}}>Recent Blogs</h2></center>

                {/* <center><h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Recent Blogs</h2></center> */}

      {posts.map((post) => (
        <div key={post.id} className="blog-post-wrapper">
          {/* Ghost Number Background */}
          {/* <div className="ghost-number">{post.id}</div> */}

          {/* Image */}
          <div className="blog-image-box">
            <img src={post.img} alt={post.title} />
          </div>

          {/* Content */}
          <div className="blog-content">
            <span className="category-label">{post.category}</span>
            <div className="tag-container">
              {post.tags.map(tag => (
                <span key={tag} className="pill-tag">{tag}</span>
              ))}
            </div>
            
            <h2 className="blog-title">{post.title}</h2>
            <p className="blog-excerpt">{post.excerpt}</p>

            <div className="blog-footer">
              <span className="blog-date">{post.date}</span>
              <a 
                href={post.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="read-story-btn"
              >
                Read Story
              </a>
            </div>
          </div>
        </div>
      ))}
  <center>
      <a className="cta-button"  href="/knowledge-center">SEE MORE BLOGS</a>
      </center>
    </div>




        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{backgroundColor: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionCentralOffice;
